import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
import Vue from "vue";

function initialState() {
  return {
    VideoPreviewModalInfo: {
      showModal: false,
      data: null
    },
    VideoUploadModalInfo: {
      showModal: false,
      data: null
    },
    VideoUploadDetails: {
      fileInfos: [],
    },
    RestartVideoLibrary: false
  };
}

const state = initialState();

const actions = {
  async getVideoSubCategories(context) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/cxp/video/subcategory"
    );
    return response ? response : null;
  },
  async searchVideoLibrary(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      "/cxp/video/search",
      request
    );
    return response && response.data ? response.data : null;
  },
  async saveVideo(context, data) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      `/cxp/video/${data.videoId > 0 ? "update" : "save"}`,
      data
    );
    return response && response.data ? response.data : null;
  },
   async getVideoUploadHistory(context, data) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      `/cxp/video/getVideoUploadHistory`,
      data
    );
    return response && response.data ? response.data : null;
  },
  async uploadVideo(context, data) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      `/cxp/video/videoUpload`,
      data
    );
    return response && response.data ? response.data : null;
  },
  async deleteVideo(context, videoId) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "DELETE",
      `/cxp/video/${videoId}/delete`,
      { videoId: videoId }
    );
    return response && response.data ? response.data : null;
  },
  updateVideoPreviewModal(context, data) {
    context.commit("updateVideoPreviewModal", data)
  },
  updateVideoUploadModal(context, data) {
    context.commit("updateVideoUploadModal", data)
  },
  updateVideoUploadDetails(context, data) {
    context.commit("updateVideoUploadDetails", data)
  },
  removeUploadVideo(context, data) {
    context.commit("removeUploadVideo", data)
  },
  updateRestartVideoLibrary(context, data) {
    context.commit("updateRestartVideoLibrary", data)
  },
};

const mutations = {
  updateRestartVideoLibrary(state, data) {
    state.RestartVideoLibrary = data;
  },
  updateVideoPreviewModal(state, data) {
    state.VideoPreviewModalInfo = data;
  },
  updateVideoUploadModal(state, data) {
    state.VideoUploadModalInfo = data;
  },
  updateVideoUploadDetails(state, data) {
    state.VideoUploadDetails.fileInfos.push(data);
  },
  removeUploadVideo(state, dataKey) {
    if (state.VideoUploadDetails.fileInfos && state.VideoUploadDetails.fileInfos.length > 0) {
      state.VideoUploadDetails.fileInfos = state.VideoUploadDetails.fileInfos.filter((fillInfo) => Number(fillInfo.id) != (dataKey));
    }
  }
};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/VideoLibrary.js